<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import "moment/locale/fr";
import * as Sentry from "@sentry/vue";

export default {
  name: "App",
  props: {
    staticFiles: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({ user: (state) => state.account.user }),
  },
  watch: {
    user: {
      handler() {
        // set sentry identifiers when an error occured
        Sentry.setUser({
          email: this.user?.email,
          username: `${this.user?.firstName} ${this.user?.lastName}`,
          id: this.user?.id,
        });
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.$setStatic(JSON.parse(this.staticFiles));
    this.initLanguage();
  },

  methods: {
    initLanguage() {
      const locale = navigator.language.includes("en")
        ? "en"
        : process.env.VUE_APP_I18N_LOCALE;
      this.$i18n.locale = locale;
      moment.locale(locale);
    },
  },
};
</script>
<style>
html {
  height: 100vh;
  overflow: auto;
}
.selected-tab {
  background: var(--v-walletPrimary-lighten5) !important;
}
</style>
